import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.iterator";
/**
 * Component: Cart add-on script
 * ------------------------------------------------------------------------------
 * Loosely coupled scripts for the Cart add-on functionality.
 *
 * @namespace cartAddOn
 */

import * as cart from '@shopify/theme-cart';
import cssClasses from '../helpers/cssClasses';
import { debounce, on } from '../helpers/utils';
/**
 * DOM selectors.
 */

const selectors = {
  container: '[js-cart-add-on="container"]',
  checkbox: '[js-cart-add-on="checkbox"]',
  message: '[js-cart-add-on="message"]',
  textarea: '[js-cart-add-on="textarea"]',
  messageLabel: '[js-cart-add-on="messageLabel"]'
};
/**
 * Create a new cart add-on object.
 */

export default (() => {
  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    container: document.querySelector(selectors.container),
    checkbox: document.querySelector(selectors.checkbox),
    message: document.querySelector(selectors.message),
    textarea: document.querySelector(selectors.textarea),
    messageLabel: document.querySelector(selectors.messageLabel)
  };
  /**
   * Initialise component.
   */

  function init() {
    setEventListeners();

    if (nodeSelectors.checkbox.checked) {
      nodeSelectors.message.style.maxHeight = "".concat(getMessageHeight(), "px");
    }
  }
  /**
   * Set event listeners.
   */


  function setEventListeners() {
    on('click', nodeSelectors.messageLabel, () => handleGiftMessageToggle());
    on('keyup', nodeSelectors.message, debounce(handleMessageUpdate, 500));
  }
  /**
   * Aggregates message container children's height & padding.
   * @returns {Number}
   */


  function getMessageHeight() {
    return [...nodeSelectors.message.children].reduce((accumulator, child) => {
      const childBound = child.getBoundingClientRect();
      const padding = getComputedStyle(child, null).getPropertyValue('padding');
      const paddingTopBottom = parseInt(padding.split(' ')[0].replace('px', ''), 10) * 2;
      return accumulator + (childBound.height + paddingTopBottom);
    }, 0);
  }
  /**
   * Set gift messaging state to active.
   */


  function setMessageActiveState() {
    nodeSelectors.container.setAttribute('data-active', true);
    nodeSelectors.checkbox.checked = false;
    nodeSelectors.message.classList.add(cssClasses.active);
    nodeSelectors.message.style.maxHeight = "".concat(getMessageHeight(), "px");
  }
  /**
   * Set gift messaging state to inactive.
   */


  function resetMessageActiveState() {
    nodeSelectors.container.setAttribute('data-active', false);
    nodeSelectors.checkbox.checked = true;
    nodeSelectors.message.classList.remove(cssClasses.active);
    nodeSelectors.message.style.maxHeight = 0;
    nodeSelectors.textarea.value = '';
  }
  /**
   * Handle gift messaging toggle event.
   */


  function handleGiftMessageToggle() {
    if (!nodeSelectors.checkbox.checked) {
      setMessageActiveState();
      return;
    }

    resetMessageActiveState();
    cart.clearNote();
  }
  /**
   * Handle text inputs on the add-on message textarea element.
   */


  function handleMessageUpdate() {
    const textAreaValue = nodeSelectors.textarea.value.trim();

    if (textAreaValue === '') {
      cart.clearNote();
      return;
    }

    cart.updateNote(textAreaValue);
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    init
  });
});